export default function DataDeletion() {
  return (
    <div className="min-h-screen bg-zinc-950 text-zinc-200 px-6 py-12">
      <div className="max-w-3xl mx-auto">
        <div className="font-mono text-xs text-[#ccff00] uppercase tracking-wider mb-3">
          TuneAmplifier
        </div>

        <h1 className="font-display text-4xl lg:text-5xl font-bold mb-3">
          User Data Deletion
        </h1>

        <p className="text-sm text-zinc-500 mb-10">
          How to request deletion of your TuneAmplifier data
        </p>

        <div className="space-y-8 text-sm leading-7 text-zinc-300">
          <section>
            <h2 className="text-xl font-display font-bold text-white mb-3">
              Request deletion
            </h2>

            <p>
              You may request deletion of your TuneAmplifier account and
              associated personal information at any time.
            </p>

            <p className="mt-4">
              Send an email to:
            </p>

            <a
              href="mailto:tuneamplifier@gmail.com?subject=TuneAmplifier%20Data%20Deletion%20Request"
              className="inline-block mt-2 text-[#ccff00] hover:underline text-base"
            >
              tuneamplifier@gmail.com
            </a>
          </section>

          <section>
            <h2 className="text-xl font-display font-bold text-white mb-3">
              What to include
            </h2>

            <ul className="list-disc pl-6 space-y-1">
              <li>The email address associated with your TuneAmplifier account</li>
              <li>
                A request stating that you want your TuneAmplifier data deleted
              </li>
            </ul>
          </section>

          <section>
            <h2 className="text-xl font-display font-bold text-white mb-3">
              Verification
            </h2>

            <p>
              We may need to verify ownership of the account before processing
              a deletion request.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-display font-bold text-white mb-3">
              What happens after a request
            </h2>

            <p>
              We will review the request and delete or anonymize applicable
              personal information, subject to information that we are required
              to retain for security, fraud prevention, financial records,
              legal obligations, or other legitimate purposes.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-display font-bold text-white mb-3">
              Third-party connections
            </h2>

            <p>
              Disconnecting a third-party service from TuneAmplifier may stop
              future access to that service. Information already stored by the
              third-party provider is governed by that provider's own data
              deletion procedures.
            </p>
          </section>

          <section className="border-t border-zinc-800 pt-6">
            <a
              href="/privacy-policy"
              className="text-[#ccff00] hover:underline"
            >
              Read the TuneAmplifier Privacy Policy
            </a>
          </section>
        </div>
      </div>
    </div>
  );
}
